import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const sendTeamInvite = (orgId, payload, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'SENDING_TEAM_INVITE' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.post(
            `/ads/org/${orgId}/team-invite`,
            payload,
            {
              params: {
                'request-id': reqId,
              },
              headers: token
                ? {
                    Authorization: `Bearer ${token}`,
                  }
                : {},
            },
          );
          if (response.status === 200) {
            dispatch({
              type: 'SENDING_TEAM_INVITE_DONE',
              payload: response?.data,
            });
            if (typeof callback === 'function') {
              callback();
            }
          } else {
            dispatch({
              type: 'SENDING_TEAM_INVITE_FAILED',
              payload: response.data.text,
            });
            if (typeof callback === 'function') {
              callback(response.data.text);
            }
          }
        } catch (e) {
          if (
            e?.response?.status === 400 &&
            e?.response?.data?.status === 400
          ) {
            if (typeof callback === 'function') {
              callback(e?.response?.data?.text);
            }
          } else {
            if (typeof callback === 'function') {
              callback(true);
            }
          }
          dispatch({
            type: 'SENDING_TEAM_INVITE_FAILED',
            payload:
              e.response && e.response.data.text
                ? e.response.data.text
                : 'Failed to send team invite',
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'SENDING_TEAM_INVITE_FAILED',
        payload: `Failed to send team invite`,
      });
      if (typeof callback === 'function') {
        callback(true);
      }
    }
  };
};

export default sendTeamInvite;
